<app-pan-action-bar class="mb-2">
  <div class="flex gap-2">
    @for (tab of tabs; track $index) {
      <button panButton color="info" [fill]="currentTab() === tab ? 'filled' : 'outline'" (click)="currentTab.set(tab)">
        {{ tab }}
      </button>
    }
  </div>

  <div class="flex-1"></div>

  <ol class="inline-flex items-center space-x-1 md:space-x-2">
    <li>
      <app-pan-button color="primary" (click)="saveProfile()" [disabled]="!profileForm().dirty()">Update Profile</app-pan-button>
    </li>

    <li>
      <app-pan-button color="info" icon="download" (click)="downloadProfile()">Export Profile</app-pan-button>
    </li>

    <li>
      <input type="file" class="hidden" #fileInput (change)="uploadProfile($event)" accept=".json" />
      <app-pan-button color="info" icon="upload" (click)="fileInput.click()">Import Profile</app-pan-button>
    </li>
  </ol>
</app-pan-action-bar>

@if (isLoading()) {
  <app-pan-blank-slate>
    <app-pan-spinner></app-pan-spinner>
  </app-pan-blank-slate>
} @else {
  <div class="grid grid-cols-2 gap-2">
    @switch (currentTab()) {
      @case ("Account Details") {
        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>Are you a member of a vending franchise or organization?</app-pan-floating-label>
          <input panInput type="text" class="form-control" [formField]="profileForm.organization" placeholder="Enter organization..." />
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>Do you collect shrink?</app-pan-floating-label>

          <ng-select
            appendTo="body"
            class="w-full"
            placeholder="Select choice..."
            [bindLabel]="'label'"
            [bindValue]="'value'"
            [clearable]="false"
            [items]="[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]"
            [formField]="profileForm.collects_shrink"
          >
          </ng-select>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your primary reason for signing up with Panoptyc?</app-pan-floating-label>
          <textarea
            panInput
            rows="5"
            type="text"
            class="form-control"
            [formField]="profileForm.sign_up_reason"
            placeholder="Enter signup details..."
          ></textarea>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What are your biggest pain points for managing shrink or loss at this location?</app-pan-floating-label>
          <textarea
            panInput
            rows="5"
            type="text"
            class="form-control"
            [formField]="profileForm.pain_points"
            placeholder="Enter pain point details..."
          ></textarea>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What goal do you hope to achieve in using Panoptyc services?</app-pan-floating-label>
          <textarea
            panInput
            rows="5"
            type="text"
            class="form-control"
            [formField]="profileForm.goal"
            placeholder="Enter goal details..."
          ></textarea>
        </app-pan-form-control>
      }

      @case ("Location Information") {
        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is the usual type of theft you're seeing?</app-pan-floating-label>

          <ng-select
            appendTo="body"
            class="w-full"
            placeholder="Select choice..."
            [items]="['Cancellation', 'Cashier', 'Underringing', 'Walkout']"
            [formField]="profileForm.usual_theft_type"
            [clearable]="false"
          >
          </ng-select>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your kiosk type?</app-pan-floating-label>

          <ng-select
            appendTo="body"
            class="w-full"
            placeholder="Select choice..."
            [items]="[
              'Applova',
              'Averigo',
              'Avanti',
              'Azure drive (Avanti)',
              'Everyday',
              'Genius',
              'Global Connect',
              'Moneta',
              'Nextep',
              'Parlevel',
              'Quick Charge',
              'Snowflake/365',
              'Threesquare',
              'Vendor\'s Exchange',
              'Yoke',
            ]"
            [formField]="profileForm.kiosk_type"
            [clearable]="false"
          >
          </ng-select>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your workplace type?</app-pan-floating-label>

          <ng-select
            appendTo="body"
            class="w-full"
            placeholder="Select choice..."
            [items]="[
              'Breakroom',
              'Dining',
              'Educational Institution',
              'Hospital/Nursing Home',
              'Government',
              'Money Room',
              'Office',
              'Retail',
              'Warehouse',
            ]"
            [formField]="profileForm.workplace_type"
            [clearable]="false"
          >
          </ng-select>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>How many kiosks do you have at this location?</app-pan-floating-label>
          <input
            panInput
            panNumericInput
            type="number"
            class="form-control"
            [formField]="profileForm.kiosk_count"
            placeholder="Enter kiosk count..."
          />
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>Indicate any location specific notes</app-pan-floating-label>
          <textarea
            panInput
            rows="5"
            type="text"
            class="form-control"
            [formField]="profileForm.notes"
            placeholder="Enter location specific notes..."
          ></textarea>
        </app-pan-form-control>
      }

      @case ("Shrink") {
        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your current shrink amount (in dollars)?</app-pan-floating-label>
          <input
            panInput
            panNumericInput
            type="number"
            class="form-control"
            [formField]="profileForm.shrink_amount"
            placeholder="Enter shrink amount..."
          />
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>Are you currently sending Panoptyc your shrink report?</app-pan-floating-label>

          <ng-select
            appendTo="body"
            class="w-full"
            placeholder="Select choice..."
            [bindLabel]="'label'"
            [bindValue]="'value'"
            [items]="[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]"
            [formField]="profileForm.sends_shrink_report"
            [clearable]="false"
          >
          </ng-select>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your shrink trend direction?</app-pan-floating-label>

          <ng-select
            appendTo="body"
            class="w-full"
            placeholder="Select choice..."
            [items]="['Improving', 'Flat', 'Worsening']"
            [formField]="profileForm.shrink_trend_direction"
            [clearable]="false"
          >
          </ng-select>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your shrink goal?</app-pan-floating-label>
          <input
            panInput
            panNumericInput
            type="number"
            class="form-control"
            [formField]="profileForm.goal"
            placeholder="Enter shrink goal..."
          />
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>Do you have restitution in place?</app-pan-floating-label>

          <ng-select
            appendTo="body"
            class="w-full"
            placeholder="Select choice..."
            [items]="['Yes', 'No']"
            [formField]="profileForm.restitution_policy"
            [clearable]="false"
          >
          </ng-select>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>How often do you audit your inventory?</app-pan-floating-label>

          <ng-select
            appendTo="body"
            class="w-full"
            placeholder="Select choice..."
            [items]="['Bi-weekly', 'Monthly', 'Semi-annually', 'Quarterly']"
            [formField]="profileForm.inventory_audit_frequency"
            [clearable]="false"
          >
          </ng-select>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your LP process?</app-pan-floating-label>
          <textarea
            panInput
            rows="5"
            type="text"
            class="form-control"
            [formField]="profileForm.lp_process"
            placeholder="How and when are you communicating shrink information to your end client?"
          ></textarea>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your restitution policy?</app-pan-floating-label>
          <textarea
            panInput
            rows="5"
            type="text"
            class="form-control"
            [formField]="profileForm.restitution_policy"
            placeholder="What contract clauses do you have to ensure you're compensated for shrink?"
          ></textarea>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>What is your HR policy?</app-pan-floating-label>
          <textarea
            panInput
            rows="5"
            type="text"
            class="form-control"
            [formField]="profileForm.hr_policy"
            placeholder="What is your end clients' HR policy on theft?"
          ></textarea>
        </app-pan-form-control>

        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>Are there any blockers to your end clients' taking action?</app-pan-floating-label>
          <textarea
            panInput
            rows="5"
            type="text"
            class="form-control"
            [formField]="profileForm.blockers"
            placeholder="What is blocking your end clients from taking action?"
          ></textarea>
        </app-pan-form-control>
      }
    }
  </div>
}
